import React from 'react';
import { Form } from 'react-bootstrap';
import { Fieldset, FormSelect, Selectize } from '~/components/FormControl';
import PropTypes from 'prop-types';
import AdventureCardBack from './AdventureCardBack';
import { API_PREFIX } from '~/pages/CardSaga/AdventureCard/adventureCard.api';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
import { useSelector } from 'react-redux';
import CardMaker from '~/components/CardMaker';
import { updateCategories } from '../../adventureCardSlice';
import { renderAdventureCardFrontEdit } from './renderAdventureCardFrontEdit';
import { blobUrlToFile } from '~/utils/helpers';

function CardInformation({ values }) {
    const { cardMetaData, backSides, resetCount } = useFormTab();
    const { keywords } = cardMetaData;
    const { categories } = useSelector((state) => state.cardSaga.adventureCard);
    const { name, categoryId } = values;

    const setCat = (form, catId) => {
        const selectedCat = categories.find((item) => item.id == catId);

        /**
         * @typedef {Object} CardTemplate
         * @property {int} id - template id.
         * @property {string} cardFrame - The URL of the card frame image (either a path or a Blob URL).
         * @property {string} cardBack - The URL of the card back image (either a path or a Blob URL).
         */

        /**
         * Clone the selected cat's template.
         * @type {CardTemplate}
         */
        const templateCloned = { ...selectedCat.template };

        for (const key in templateCloned) {
            if (typeof templateCloned[key] === 'string' && templateCloned[key].startsWith('blob:')) {
                blobUrlToFile(templateCloned[key]).then((fileObj) => {
                    templateCloned[key] = fileObj;
                });
            }
        }

        form.setFieldValue('template', templateCloned);
    };

    return (
        <>
            <FormSelect
                name="categoryId"
                options={categories || []}
                sm={3}
                className={'offset-sm-4'}
                onChangeValue={setCat}
            />
            <Fieldset sm={12}>
                <Fieldset.Legend>Card Maker</Fieldset.Legend>
                <CardMaker
                    values={values}
                    apiPrefix={API_PREFIX}
                    iconWidth={96}
                    iconHeight={70}
                    cardBackElement={
                        <AdventureCardBack
                            pictureName={backSides[0]}
                            pictureVal={backSides[0].split('.').reduce((a, b) => a[b], values)}
                            resetCount={resetCount}
                            categories={categories}
                            categoryId={values.categoryId}
                            updateCategories={updateCategories}
                        />
                    }
                    renderCardFrontEdit={renderAdventureCardFrontEdit(name, categoryId, categories)}
                    iconOrCrop={'crop'}
                />
            </Fieldset>

            <Form.Row>
                <Selectize
                    sm="3"
                    name="keywords"
                    options={keywords ?? []}
                    note="* only published keywords are available for selection."
                />
            </Form.Row>
        </>
    );
}

CardInformation.propTypes = {
    values: PropTypes.object.isRequired,
};
export default CardInformation;
